import { render, staticRenderFns } from "./Q13Info.vue?vue&type=template&id=08cbf219&"
import script from "./Q13Info.vue?vue&type=script&lang=ts&"
export * from "./Q13Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports